'use strict';

angular.module('systemOwnerReviewRoutes.ReviewUniquePermissions', ['systemOwnerReviewControllers.ReviewUniquePermissions'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('systemOwnerReview.authUser.reviewUniquePermissions', {
            url: '/ReviewUniquePermissions',
            views: {
                '': {
                    templateUrl: require('./ReviewUniquePermissions.tpl.html'),
                    controller: 'ReviewUniquePermissionsController'
                },
                'sidebar@systemOwnerReview.authUser.reviewUniquePermissions': {
                    templateUrl: require('./SideBar.tpl.html'),
                    controller: 'SideBarUniquePermissionsController'
                }
            },
            resolve: {
                systemTypesToReview: ['reviewUniquePermissionsService', '$stateParams', function (service, $stateParams) {
                    return service.getSystemTypesToReview($stateParams.authLogin);
                }]
            }
        })

        // Explanations
        .state('systemOwnerReview.authUser.reviewUniquePermissionsExplanation', {
            url: '/ReviewUniquePermissions_Explanation',
            templateUrl: require('./Explanation1.tpl.html'),
            controller: 'ExplanationReviewUniquePermissionsController'
        })

        // By System Type
        .state('systemOwnerReview.authUser.reviewUniquePermissions.noSystem', {
            url: '/NoSystem',
            views: {
                'details@systemOwnerReview.authUser.reviewUniquePermissions': {
                    templateUrl: require('./noSystemType.tpl.html'),
                    controller: 'UniquePermissionsBySystemTypeController',
                    resolve: {
                        systemType: function () {
                            return {};
                        },
                        systemRolesToReview: function () {
                            return [];
                        }
                    }
                }
            }
        })

        // By System Type
        .state('systemOwnerReview.authUser.reviewUniquePermissions.bySystemType', {
            url: '/{systemTypeSlug}',
            views: {
                'details@systemOwnerReview.authUser.reviewUniquePermissions': {
                    templateUrl: require('./BySystemType.tpl.html'),
                    controller: 'UniquePermissionsBySystemTypeController',
                    resolve: {
                        systemType: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                            return service.getSystemTypeBySlug($stateParams.systemTypeSlug);
                        }],
                        systemRolesToReview: ['reviewUniquePermissionsService', 'systemType', '$stateParams', function (service, systemType, $stateParams) {
                            return service.getSystemRolesToReviewBySystemType($stateParams.authLogin, systemType.SystemTypeID);
                        }]
                    }
                }
            }
        });

}]);
